export enum EntityType {
  ENTITLEMENT = 'Entitlement',
  INVOICE = 'Invoice',
  QUOTE = 'Quote',
}
